(ns opengb.i18n.format
  (:require [clojure.string :as string]
            [opengb.i18n.locale :as i18n.locale])
  #?(:clj  (:import (com.ibm.icu.number NumberFormatter FractionPrecision)
                    (com.ibm.icu.text MessageFormat)
                    (com.ibm.icu.util ULocale)))
  #?(:cljs (:require ["@messageformat/core" :as messageformatjs])))

;;
;; Number Formatting
;;

;; NumberFormatter
;; https://unicode-org.github.io/icu-docs/apidoc/dev/icu4j/com/ibm/icu/number/NumberFormatter.html

;; Intl.Locale
;; https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale

;; Intl.NumberFormat
;; https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat

(defn format-number
  "Takes in a number to format and a params map containing a locale keyword and
  number of decimal places. Defaults to :en-CA and 0 decimals."
  [n {:keys [:opengb.quantity.format/mag-decimal-places
             :opengb.quantity.format/is-year?]
      :or {mag-decimal-places 0} :as params}]
  (if is-year?
    (str (int n))
    (let [locale (or (:opengb.i18n/locale params) i18n.locale/default-locale)]
      #?(:clj  (let [java-locale (ULocale. (name locale))
                     precision (FractionPrecision/fixedFraction mag-decimal-places)]
                 (-> (NumberFormatter/withLocale java-locale)
                     (.precision precision)
                     (.format n)
                     (.toString)))
         :cljs (let [js-locale (name locale)
                     options (clj->js {:minimumFractionDigits mag-decimal-places
                                       :maximumFractionDigits mag-decimal-places})
                     nf (js/Intl.NumberFormat. js-locale options)
                     result (.format nf n)]
                 result)))))

(comment
  (format-number 1234.5678 {})
  (format-number 1234.5678 {:opengb.i18n/locale :en-CA})
  (format-number 1234.5678 {:opengb.i18n/locale :en-CA
                            :opengb.quantity.format/mag-decimal-places 2})
  (format-number 1234.5678 {:opengb.i18n/locale :fr-CA
                            :opengb.quantity.format/mag-decimal-places 4})
  (format-number 1988.0000 {:opengb.i18n/locale :fr-CA
                            :opengb.quantity.format/is-year? true}))

;;
;; String Formatting
;;

;; MessageFormat 
;; https://unicode-org.github.io/icu-docs/apidoc/dev/icu4j/com/ibm/icu/text/MessageFormat

;; messageformatjs 
;; http://messageformat.github.io/messageformat/api/core.messageformat/

;; MessageFormat with Locale

(defn params->mf-params
  "MessageFormat params must have string keys that don't use hyphens."
  [params]
  (update-keys params (comp #(string/replace % #"-" "_")
                            name)))

(defn format-mf
  "Takes in a MessageFormat pattern and params (including locale). Returns an
  interpolated string formatted for the locale."
  [pattern {:keys [:opengb.i18n/locale] :as params}]
  #?(:clj  (let [mf (MessageFormat. pattern (ULocale. (name locale)))
                 params' (params->mf-params params)]
             (.format mf params'))
     :cljs (let [mf (.compile (messageformatjs. (name locale)) pattern)
                 params' (-> params
                             params->mf-params
                             clj->js)]
             (mf params'))))

(comment
  (format-mf "Hi, {name}" {:name "Andrew" :opengb.i18n/locale :en-CA})
  (format-mf "{n, number}" {:n 12345.67 :opengb.i18n/locale :en-CA})
  (format-mf "Showing {visible_properties, number} out of {total_properties, plural, one {# property} other {# properties}}" {:visible_properties 1234 :total-properties 2345 :opengb.i18n/locale :en-CA}))
